<template>
  <defaultFrame></defaultFrame>
</template>


<script lang="ts">
export default {
  name:'defaultFrameCom'
}
</script>
<script lang="ts" setup>
import DefaultFrame from '../defaultFrame/index.vue';
import {baseHandler} from "@/layouts/default/setting/handler";
import {HandlerEnum} from "@/layouts/default/setting/enum";
import {unref} from "vue";
import {MenuModeEnum, MenuTypeEnum} from "@/enums/menuEnum";
import {useMenuSetting} from "@/hooks/setting/useMenuSetting";

const {
  getIsHorizontal,
  getCollapsed,
  getSplit,
} = useMenuSetting();

baseHandler(HandlerEnum.CHANGE_LAYOUT, {
  mode: MenuModeEnum.INLINE,
  type: MenuTypeEnum.SIDEBAR,
  split: unref(getIsHorizontal) ? false : undefined,
});
</script>

<style type="text/css" lang="less"></style>
